import React from 'react';
import { Wand2 } from 'lucide-react';

export const SearchIcon = ({ className = "w-6 h-6" }) => (
  <Wand2 className={className} />
); 